
import enterView from 'enter-view';


// 
var elements = document.getElementsByClassName('ev-fadeup');

Array.from(elements).forEach(function(el) { // Now you have each element as a DOM element
	
	if (el.getAttribute('data-ev-offset')) { // Use offset from data attr

		// console.log('has offset');
		var offset = parseFloat(el.getAttribute('data-ev-offset'));
		enterView({
			selector: '.ev-fadeup[data-ev-offset="' + offset +'"]',
			enter: function(element) {
				element.classList.add('ev-entered');
			},
			exit: function(element) {
				element.classList.remove('ev-entered');
			},
			offset: offset,
			once: false
		});

	} else {

		enterView({
			selector: '.ev-fadeup:not([data-ev-offset]',
			enter: function(element) { // Use default offset
				element.classList.add('ev-entered');
			},
			exit: function(element) {
				element.classList.remove('ev-entered');
			},
			offset: 0.4,
			once: false
		});

	}

	// console.log(offset);
	
});





// Stats
var stats = document.querySelectorAll('.ev-stat');

if (stats.length > 0) {

	enterView({
		selector: '.ev-stat',
		enter: function(el) {
			el.classList.add('ev-entered');
		},
		exit: function(el) {
			el.classList.remove('ev-entered');
		},
		offset: 0.5, 
		once: false,
	});

}





//Main Footer
// enterView({
// 	selector: '.ev-footer',
// 	enter: function(el) {
// 		el.classList.add('ev-entered');
// 	},
// 	exit: function(el) {
// 		el.classList.remove('ev-entered');
// 	},
// 	offset: 0.1, 
// 	once: false,
// });



// document.getElementsByClassName('ev-fadeup').forEach(function(el) {
//     var offset = parseFloat(el.getAttribute('data-ev-delay')) || 0.5;


// 	// var xmlString = "<div id='foo'><a href='#'>Link</a><span></span></div>";
// 	// var doc = new DOMParser().parseFromString(xmlString, "text/xml");
// 	// console.log(doc.firstChild.innerHTML); // => <a href="#">Link...
// 	// console.log(doc.firstChild.firstChild.innerHTML); // => Link

// 	// const test = selectionToArray('.ev-fadeup');

// 	// console.log(el);

//     enterView({
//         selector: el,
//         enter: function(element) {
//             element.classList.add('ev-entered');
//         },
//         exit: function(element) {
//             element.classList.remove('ev-entered');
//         },
//         offset: offset,
//         once: false
//     });
// });


// const offset = 0.9;

// enterView({
// 	selector: '.ev-fadeup',
// 	enter: function(el) {
// 		el.classList.add('ev-entered');
// 		console.log('hello');
// 		console.log(el);
// 	},
// 	exit: function(el) {
// 		el.classList.remove('ev-entered');
// 	},
// 	offset: offset, 
// 	once: false,
// });






		// // Check if the element has the data-ev-delay attribute
		// if (el.hasAttribute('data-ev-delay')) {
		// 	// Get the value of data-ev-delay attribute and convert it to a number
		// 	const delay = parseFloat(el.getAttribute('data-ev-delay'));
		// 	// Use the delay as the offset
		// 	return delay;
		// } else {
		// 	// Default offset if data-ev-delay attribute is not present
		// 	return 0.5;
		// }